<div mat-dialog-title>
  <h2>{{'group-management.import_learners_list' | translate}}</h2>
  <button class="close"
    (click)="dialogRef.close()"
    aria-label="Close dialog">
    <mat-icon svgIcon="cross"></mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (!done) {
    <div>
      <div [innerHTML]="page?.get('body')"></div>
      <div>
        @if (importInClasses) {
          <mat-form-field appearance="fill">
            <mat-label>{{ 'groups-management.assign_to_class' | translate }}</mat-label>
            <mat-select [(value)]="selectedGroup">
              @for (group of groups; track group) {
                <mat-option [value]="group">
                  {{ group['groupname'] }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </div>
      <button mat-raised-button color="primary" (click)="fileInput.click()">
        <span>{{ 'corpus.import_file' | translate }}</span>
        <input hidden type="file" #fileInput (change)="onFileChanged($event)" id="fileToUpload" />
      </button>
      @if (fileName && !done && !fileError) {
        <span>{{ fileName | translate }}</span>
      }
      @if (fileError) {
        <mat-error>{{ fileError | translate }}</mat-error>
      }
      @if (fileName && done) {
        <span>{{ fileName }}</span>
      }
    </div>
  }

  @if (done) {
    <div>
      @for (field of objectKeys(result['attributes']); track field) {
        <div>
          @if (result['attributes'][field]) {
            <span>
              <span [innerHTML]="field | translate"></span> : {{ result['attributes'][field] }}
            </span>
          }
          @if (field === 'groups-management.username_taken' && result['attributes'][field]) {
            <p [innerHTML]="'groups-management.username_taken_description' | translate"></p>
          }
        </div>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (!done) {
    <button
      (click)="importLearners()"
      [disabled]="!uploaded"
      mat-raised-button
    class="mat-accent">{{'group-management.import' | translate}}</button>
  }


  @if (!done) {
    <button
      (click)="dialogRef.close()"
      mat-raised-button
    class="mat-accent">{{'generic.cancel' | translate}}</button>
  }

  @if (done) {
    <button
      (click)="dialogRef.close()"
      mat-raised-button
    class="mat-accent">{{'generic.ok' | translate}}</button>
  }
</mat-dialog-actions>